import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

export default create(subscribeWithSelector((set) => 
{
  return{
    linksCount: 3,
    space: 'home',

    transitionDone: true,
    setTransitionDone: (done) => set({ transitionDone: done }),
   
    // 🔊 Background music state
    startBgMusic: false,
    setStartBgMusic: (value) => set({ startBgMusic: value }),

    julkaisut: () => {
      set((state) => {
          if(state.space !== 'table')
            return { space: 'table' }
            return {}
      })
    },

    ulkomainokset: () => {
      set((state) => {
          if(state.space !== 'alley')
            return { space: 'alley' }
            return {}
      })
    },

    informaatio: () => {
      set((state) => {
        if(state.space !== 'wall')
          return { space: 'wall' }
          return {}
      })
    },

    installaatiot: () => {
      set((state) => {
        if(state.space !== 'arthouse')
          return { space: 'arthouse' }
          return {}
      })
    },

    livevisuals: () => {
      set((state) => {
        if(state.space !== 'stage')
          return { space: 'stage' }
          return {}
      })
    }

  }
}))